import { GET_ALL_RESOLUTION } from '../../types'

const INITIAL_STATE = {
  getAllResolution: [],
}

const resolutionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_RESOLUTION:
      return {
        ...state,
        getAllResolution: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default resolutionReducer
